        AOS.init({
      duration: 1000
    });



   var myID = document.getElementById("myID");
  var myScrollFunc = function () {
      var y = window.scrollY;
      var windowHeight = window.innerHeight;
      var documentHeight = document.documentElement.scrollHeight;
      // Check if the user is at the bottom of the page
      if (y + windowHeight >= documentHeight) {
          myID.className = "bottomMenu hide";
      } else if (y >= 150) {
          myID.className = "bottomMenu show";
      } else {
          myID.className = "bottomMenu hide";
      }
  };
  window.addEventListener("scroll", myScrollFunc);




  $(document).ready(function() {
    $(".set > a").on("click", function(event) {
      event.preventDefault();

      // Remove active state from all other anchors
      $(".set > a").not(this).removeClass("active");
      $(".set > a").not(this).find("i").removeClass("fa-minus").addClass("fa-plus");
      
      // Close all other content
      $(".content").not($(this).next(".content")).slideUp(200);
      
      // Toggle the current content
      $(this).toggleClass("active");
      $(this).find("i").toggleClass("fa-plus fa-minus");
      $(this).next(".content").slideToggle(200);
    });
  });




$('.custom_blocks_sec .outer_loop_new').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows:true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '60px'
      }
    },
    {
      breakpoint: 600,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.responsive-col').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows:false,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows:true,
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 880,
      settings: {
        arrows:true,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
         arrows:true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.featured-col-center').slick({
  dots: false,
  centerMode: true,
  centerPadding: '280px',
  infinite: true,
  speed: 300,
  arrows:true,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        arrows:true,
        centerMode: true,
        centerPadding: '180px',
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 880,
      settings: {
        arrows:true,
        dots: true,
        centerMode: false,
        centerPadding: '80px',
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 680,
      settings: {
        arrows:true,
        centerMode: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});





$('.custom-logo-slider .slick-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
 autoplay: true,         // Enables autoplay
  autoplaySpeed: 2000,
  arrows:false,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2,
         arrows:true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});







$(function () {
  const $slider = $('.slide_new_marqee');
  
  // Clone the slides for a seamless effect
  $slider
    .slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,            // Adjust speed for smooth continuous effect
      arrows: false,
      swipe: false,
      infinite: true,          // Enables infinite loop
      slidesToShow: 5,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      variableWidth: true,     // Allows slide items to have different widths if needed
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
});




 $(document).ready(function () {
    function initMobileSlider() {
      if ($(window).width() < 768 && !$('.main_hmc_list').hasClass('slick-initialized')) {
        $('.main_hmc_list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true,
  autoplaySpeed: 3000, 
          infinite: true,
        });
      } else if ($(window).width() >= 768 && $('.main_hmc_list').hasClass('slick-initialized')) {
        $('.main_hmc_list').slick('unslick');
      }
    }

    initMobileSlider();
    $(window).on('resize', function () {
      initMobileSlider();
    });
  });




  

$('.main_testi_slider').slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,

  prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>' +
               '</svg>' +
             '</button>',
  nextArrow: '<button type="button" class="slick-next" aria-label="Next">' +
               '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                 '<path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>' +
               '</svg>' +
             '</button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
  centerPadding: "40px",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      }
    }
  ]
});
